/** UI sentinel shown for stored secrets that must not be written back. */
export const MASKED_SECRET = '••••••';

/** Legacy OTP / form sentinel still accepted when ignoring unchanged secrets. */
export const LEGACY_MASKED_SECRET = '********';

/** True when `value` is a mask sentinel, not a real secret. */
export function isMaskedSecret(
  value: string | boolean | undefined | null,
): boolean {
  return value === MASKED_SECRET || value === LEGACY_MASKED_SECRET;
}
